import { render, staticRenderFns } from "./404.vue?vue&type=template&id=54774fea&scoped=true"
import script from "./404.js?vue&type=script&lang=js&external"
export * from "./404.js?vue&type=script&lang=js&external"
import style0 from "./404.scss?vue&type=style&index=0&id=54774fea&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54774fea",
  null
  
)

export default component.exports